export const TRENDS_ANALYTICS_METADATA = {
  featureVersion: 'spendVsIncomeTrends',
}
